function getBaseDomain(hostname) {
  const parts = hostname.split('.');
  return parts.slice(-2).join('.');
}

function isFullUrl(url) {
  return url.startsWith('http://') || url.startsWith('https://');
}

function safePath(value) {
  if (value && value.startsWith('/') && !value.startsWith('//')) {
    return value;
  }
  return '/';
}

function resolveReturnUrl(returnParam, appRedirect, token) {
  let base;

  if (isFullUrl(returnParam)) {
    try {
      const returnUrl = new URL(returnParam);
      const appUrl = new URL(appRedirect);
      const fallbackPath = returnUrl.pathname + returnUrl.search;

      if (returnUrl.hostname === 'localhost' || getBaseDomain(returnUrl.hostname) === getBaseDomain(appUrl.hostname)) {
        base = returnParam;
      } else {
        base = appRedirect + fallbackPath;
      }
    } catch (e) {
      base = appRedirect + '/';
    }
  } else {
    base = appRedirect + safePath(returnParam);
  }

  if (token) {
    const separator = base.includes('?') ? '&' : '?';
    return `${base}${separator}token=${token}`;
  }

  return base;
}

export { resolveReturnUrl };
